import { assistantChartImageId } from "@inrev/common";
import * as z from "zod";

/**
 * A PNG the agent's `run_chart_code` drew, stored under the conversation by apps/api. The tool
 * returns the whole block, so the agent pastes it rather than writing it.
 */
export const imageChartSchema = z.strictObject({
	source: z.literal("image"),
	imageId: assistantChartImageId,
	title: z.string().optional(),
});

export type ImageChart = z.infer<typeof imageChartSchema>;
